// import { useParams } from "react-router-dom";
// import { getLocalStorageItem } from "../utils";
// import {ApiService , ApiService2} from "./Axios";

// export const getHeaders = (requireAuth=true) => {
//   let headers = {
//     'Content-Type' : 'application/x-www-form-urlencoded',
//   };
//   if (requireAuth) {
//     const accessToken  = `Bearer ${getLocalStorageItem("token_vendor")}`;
//     headers.Authorization = `${accessToken}`;
//   }
//   return headers;
// };

// export const Get = (url) =>
//   ApiService.get(url, { headers: getHeaders() });

//   export const BankGet = (url) =>
//   ApiService2.get(url, { headers: getHeaders() });

// export const Post = (url, data,auth) =>
//   ApiService.post(url, data, { headers: getHeaders(auth)});


// export const Patch = (url, data) =>
//   ApiService.patch(url, data, { headers: getHeaders() });

//   export const Put = (url, data) =>
//   ApiService.put(url, data, { headers: getHeaders() }); 
  
// export const Delete = (url) =>
//   ApiService.delete(url, { headers: getHeaders() });

// export const getAPIUrl = (url, params = "") => {
//   return url + `${params}`;
// };
// export const FormDataPost=(url,data)=>{
//   return ApiService.post(url, data, { headers: {
//     "Content-Type": "multipart/form-data",
//   } }); 

// }
// export const FormDataPatch=(url,data)=>{
//   return ApiService.patch(url, data, { headers: {
//     "Content-Type": "multipart/form-data",
//   } }); 

// }
// export const getErrors = (error) => {
//   const errorData = error.response.data.error;
//   const errors = {};
//   Object.keys(errorData).forEach((key) => {
//     errors[key] = errorData[key];
//   });
//   return errors;
// };





import { getLocalStorageItem } from "../utils";
import { ApiService, ApiService2 } from "./Axios";

export const getHeaders = (requireAuth = true) => {
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    "ngrok-skip-browser-warning": "true",
  };

  if (requireAuth) {
    headers.Authorization = `Bearer ${getLocalStorageItem("token_vendor")}`;
  }

  return headers;
};

export const Get = (url) =>
  ApiService.get(url, { headers: getHeaders() });

export const BankGet = (url) =>
  ApiService2.get(url, { headers: getHeaders() });

export const Post = (url, data, auth = true) =>
  ApiService.post(url, data, { headers: getHeaders(auth) });

export const Patch = (url, data) =>
  ApiService.patch(url, data, { headers: getHeaders() });

export const Put = (url, data) =>
  ApiService.put(url, data, { headers: getHeaders() });

export const Delete = (url) =>
  ApiService.delete(url, { headers: getHeaders() });

export const getAPIUrl = (url, params = "") => {
  return url + `${params}`;
};

export const FormDataPost = (url, data) => {
  return ApiService.post(url, data, {
    headers: {
      Authorization: `Bearer ${getLocalStorageItem("token_vendor")}`,
      "Content-Type": "multipart/form-data",
      "ngrok-skip-browser-warning": "true",
    },
  });
};

export const FormDataPatch = (url, data) => {
  return ApiService.patch(url, data, {
    headers: {
      Authorization: `Bearer ${getLocalStorageItem("token_vendor")}`,
      "Content-Type": "multipart/form-data",
      "ngrok-skip-browser-warning": "true",
    },
  });
};

export const getErrors = (error) => {
  const errorData = error.response.data.error;
  const errors = {};

  Object.keys(errorData).forEach((key) => {
    errors[key] = errorData[key];
  });

  return errors;
};